import React, { useState } from 'react'
import { useContext } from 'react'
import { HelpDiv, HelpHeader, HelpAnswer, Expand } from "../styles/help"
import ExpandIcon from '../assets/icons/expand.svg'
import { Toggle } from "../styles/giftList"
import { LocaleContext } from '../routes'

export default faq => {
  const [collapsed, setCollapsed] = useState()
  const toggle = () => setCollapsed(!collapsed)

  const clip = text => {
    let length = 200
    if (text.length > length) {
      while (text[length - 1] !== ' ') {
        length++
      }
      return text.substr(0, length) + ' ...'
    }
    return text
  }

  const expandedAnswerText = faq.faq.answer
  const clippedAnswerText = clip(expandedAnswerText)
  const [answerText, setAnswerText] = useState(clippedAnswerText)
  const [isClipped, setClipped] = useState(clippedAnswerText.length < expandedAnswerText.length)

  const locale = useContext(LocaleContext)

  const expand = () => {
    setAnswerText(expandedAnswerText)
    setClipped(false)
  }

  return (
    <HelpDiv collapsed={collapsed}>
      <HelpHeader onClick={toggle}>
        {faq.faq.question}
        <Toggle src={ExpandIcon} alt="" collapsed={!collapsed} />
      </HelpHeader>
      <HelpAnswer collapsed={collapsed} onClick={expand}>
        {answerText}
        {isClipped &&
          <Expand onClick={expand}>{locale.EXPAND}</Expand>
        }
      </HelpAnswer>
    </HelpDiv>
  )
}